import type { ModuleSnapshot } from '@ctcells/contract'
import { enumLabel } from '@ctcells/i18n'
import { createContext } from 'react'

import type { ChamberStage } from '../../figures/chamber3d/chamberScene.ts'

/**
 * **진행 중인 챔버 아래 「지금 하는 일」 한 줄** — 그 단계 모듈의 지금 상태 · 동작 이름(eric 2026-10-08 「시료에서 어셈블러 진행 이렇게 되는데..
 * 해당 챔버가 진행 중일 때는 진행 중인 내용도 보여줘」).
 *
 * | 단계 | 모듈 | 글자 |
 * | --- | --- | --- |
 * | `centrifuged` | 원심분리기 | 상태 이름(적재 중 · 실행 중 · 회수 중 …) |
 * | `assembled` | 어셈블러 | 상태 이름(TC 장착 · UV 노출 · TC 분리 · 적재 중 …) |
 * | `staining` | 염색기 | 동작 이름(시약 넣는 중 · 흡입 …) · 없으면 상태 이름 |
 *
 * 🔴 서버 사실만 — `ModuleSnapshot.state` · `current_execution.sequence`. 대기(`IDLE`) · 끊긴 화면 · 낡은 스냅샷이면 글자가 없다.
 * 🔴 «어느 챔버»인지는 부르는 쪽이 정한다 — 그 챔버가 서버 근거로 「진행」일 때만 이 글자를 단다(`BundleChamber`).
 */
export type ChamberActivity = Partial<Record<ChamberStage, string>>

export const ChamberActivityContext = createContext<ChamberActivity>({})

const STAGE_OF_TYPE: Readonly<Record<string, ChamberStage>> = {
  centrifuge: 'centrifuged',
  assembler: 'assembled',
  staining: 'staining',
}

export function chamberActivityOf(
  modules: readonly ModuleSnapshot[],
  stale: boolean,
): ChamberActivity {
  if (stale) return {}
  const out: ChamberActivity = {}
  for (const m of modules) {
    const stage = STAGE_OF_TYPE[m.module_type]
    if (stage === undefined || m.stale === true || m.state === 'IDLE') continue
    const sequence = m.current_execution?.sequence
    const text =
      stage === 'staining' && typeof sequence === 'string' && sequence !== ''
        ? enumLabel('enum.stainSequence', sequence)
        : enumLabel('enum.moduleState', m.state)
    if (text !== '' && text !== '—') out[stage] = text
  }
  return out
}
